import { Route, Routes } from 'react-router-dom';
import { MapScope } from '@/graphql/types';
import { MapPage } from './MapPage';

export function MapRoutes() {
    return (
        <Routes>
            <Route index element={<MapPage scope={MapScope.User} />} />
            <Route path="admin" element={<MapPage scope={MapScope.Admin} />} />
        </Routes>
    );
}
